import HttpClient from "../../HttpClient";
import apiRoutes from "../../Routes/Routes.json";

// ViewRequisitionController — V2 worklist endpoints (raw HTTP calls).
// Typed/normalised wrappers live in Pages/Requisition/ViewRequisitionV2/services/worklistApi.ts.
const routes = apiRoutes.Requisition;

type Opts = { signal?: AbortSignal };

// All tabs with their columns (cached server-side, evicted by SaveColumnsV2).
const getTabColumns = ({ signal }: Opts = {}) =>
  HttpClient().get(`/${routes.viewRequisitionV2TabColumns}`, { signal });

const getPage = (request: object, { signal }: Opts = {}) =>
  HttpClient().post(`/${routes.viewRequisitionV2Page}`, request, { signal });

const getCount = (request: object, { signal }: Opts = {}) =>
  HttpClient().post(`/${routes.viewRequisitionV2Count}`, request, { signal });

const getTabCounts = (refresh = false, { signal }: Opts = {}) =>
  HttpClient().get(`/${routes.viewRequisitionV2TabCounts}`, {
    params: { refresh },
    signal,
  });

const getDetail = (
  requisitionOrderId: number,
  tabId: number,
  { signal }: Opts = {}
) =>
  HttpClient().get(
    `/${routes.viewRequisitionV2Detail.replace(
      "{requisitionOrderId}",
      String(requisitionOrderId)
    )}`,
    { params: { tabId }, signal }
  );

const getFilterOptions = (
  tabId: number,
  columnId: number,
  { signal }: Opts = {}
) =>
  HttpClient().get(`/${routes.viewRequisitionV2FilterOptions}`, {
    params: { tabId, columnId },
    signal,
  });

const saveColumns = (request: object) =>
  HttpClient().post(`/${routes.viewRequisitionV2SaveColumns}`, request);

const exportCsv = (request: object, { signal }: Opts = {}) =>
  HttpClient().post(`/${routes.viewRequisitionV2ExportCsv}`, request, {
    responseType: "blob",
    signal,
  });

const ViewRequisitionV2Service = {
  getTabColumns,
  getPage,
  getCount,
  getTabCounts,
  getDetail,
  getFilterOptions,
  saveColumns,
  exportCsv,
};

export default ViewRequisitionV2Service;
